import script from "./ParentListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentListPage.vue?vue&type=script&setup=true&lang=js"

import "./ParentListPage.vue?vue&type=style&index=0&id=681247bc&lang=css"

const __exports__ = script;

export default __exports__